import { useState } from "react";
import { toast } from "sonner";
import { Copy, CheckCircle2, Cog, Clock, MapPin, Phone, CalendarDays } from "lucide-react";
import { formatMoney } from "@/lib/api";

export const copiar = (t) => {
  if (!t) return;
  navigator.clipboard?.writeText(String(t)).then(() => toast.success("Copiado"), () => toast.error("No se pudo copiar"));
};

export const BtnCopiar = ({ t, id }) => (
  <button type="button" onClick={() => copiar(t)} className="inline-flex p-0.5 text-zinc-500 hover:text-black shrink-0" title="Copiar" data-testid={id}>
    <Copy className="w-3.5 h-3.5" />
  </button>
);

const FAB = { fabricado: ["bg-emerald-50 text-emerald-800 border-emerald-200", CheckCircle2, "text-emerald-600"],
  en_proceso: ["bg-orange-50 text-orange-800 border-orange-200", Cog, "text-orange-500"],
  pendiente: ["bg-red-50 text-red-700 border-red-200", Clock, "text-red-600"] };
const EMP = { empacado: FAB.fabricado, parcial: ["bg-amber-50 text-amber-800 border-amber-200", Clock, "text-amber-500"], pendiente: FAB.pendiente };

export const Pill = ({ k, lbl, tipo, id }) => {
  const [c, Icon, ic] = (tipo === "fab" ? FAB : EMP)[k] || FAB.pendiente;
  return (
    <span className={`inline-flex items-center gap-1.5 w-full justify-center rounded-md border px-2 py-1.5 text-xs font-bold ${c}`} data-testid={id}>
      <Icon className={`w-4 h-4 ${ic}`} /> {lbl}
    </span>
  );
};

export const ClienteCelda = ({ r, abierto }) => {
  const c = r.cliente;
  return (
    <div className="space-y-1 text-[12px] leading-snug" data-testid={`org-cliente-${r.numero}`}>
      <div className="flex items-start gap-1 font-black uppercase text-[13px]">{c.nombre}<BtnCopiar t={c.nombre} id={`org-copiar-nombre-${r.numero}`} /></div>
      {abierto && (
        <>
          <div className="flex items-start gap-1"><MapPin className="w-3.5 h-3.5 mt-0.5 shrink-0" /><span className="uppercase">{c.direccion}</span><BtnCopiar t={c.direccion} id={`org-copiar-dir-${r.numero}`} /></div>
          {c.telefonos.length > 0 && (
            <div className="flex items-center gap-1 font-bold"><Phone className="w-3.5 h-3.5 text-emerald-600 shrink-0" />{c.telefonos.join(" / ")}<BtnCopiar t={c.telefonos.join(" / ")} id={`org-copiar-tel-${r.numero}`} /></div>
          )}
          {c.entrega && <div className="flex items-center gap-1"><CalendarDays className="w-3.5 h-3.5 shrink-0" />Entrega: {c.entrega}<BtnCopiar t={c.entrega} id={`org-copiar-entrega-${r.numero}`} /></div>}
        </>
      )}
    </div>
  );
};

export const PagoCelda = ({ r, abierto }) => {
  const p = r.pago;
  return (
    <div className="text-[13px] leading-relaxed" data-testid={`org-pago-${r.numero}`}>
      {abierto && (
        <>
          <div><b>Total:</b> {formatMoney(p.total)}</div>
          <div><b>Anticipos:</b> {formatMoney(p.anticipo)}</div>
          <div><b>Pagos:</b> {formatMoney(p.pagos)}</div>
        </>
      )}
      <div className="flex items-center gap-1"><b>A cobrar:</b> <span className="text-[#1D4ED8] font-black">{formatMoney(p.a_cobrar)}</span>
        <BtnCopiar t={Number(p.a_cobrar).toFixed(2)} id={`org-copiar-cobrar-${r.numero}`} /></div>
    </div>
  );
};

export const useToggle = (v = true) => {
  const [s, set] = useState(v);
  return [s, () => set((x) => !x)];
};
